import { useCallback } from 'react';
import { addModule as addModuleAction } from '../redux/actions/layout';
import { useDispatch } from 'react-redux';
import usePrivileges from './usePrivileges';
import { useGruser } from './useGruser';
export const useLayoutActions = ()=>{
    const { gruser } = useGruser();
    const dispatch = useDispatch();
    const { canAddModule } = usePrivileges();
    const dispatchAddModule = useCallback((moduleName, zoneName, position)=>dispatch(addModuleAction(gruser, {
            zoneName,
            moduleName,
            position
        })), [
        dispatch,
        gruser
    ]);
    const addModule = canAddModule ? dispatchAddModule : undefined;
    return {
        canAddModule,
        addModule
    };
};

//# sourceMappingURL=useLayoutActions.js.map